(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["variant-pills"] && !Shopify.designMode) return;
  try {
    (function () {
  if (window.housiousVariantPillsInitialized) return;
  window.housiousVariantPillsInitialized = true;

  document.addEventListener('click', function (e) {
    var viewAll = e.target.closest('.housious-variant-viewall');
    if (viewAll) {
      var group = viewAll.closest('.housious-variant-pills');
      if (!group) return;
      var total = group.querySelectorAll('.housious-variant-pill[data-variant-id]').length;
      var expanded = group.classList.toggle('is-expanded');
      viewAll.setAttribute('aria-expanded', String(expanded));
      var text = viewAll.querySelector('.viewall-text');
      if (text) text.textContent = expanded ? 'Show less' : 'View all (' + total + ')';
      return;
    }

    var pill = e.target.closest('.housious-variant-pill');
    if (!pill) return;
    var container = pill.closest('.product-variant-selector');
    if (!container) return;

    container.querySelectorAll('.housious-variant-pill').forEach(function (p) {
      p.classList.remove('is-selected');
      p.setAttribute('aria-checked', 'false');
    });
    pill.classList.add('is-selected');
    pill.setAttribute('aria-checked', 'true');

    var titleDisplay = container.querySelector('[data-selected-variant-title]');
    if (titleDisplay) titleDisplay.textContent = pill.getAttribute('data-variant-title') || '';

    var productSection = container.closest('.shopify-section');
    var productInfo = container.closest('product-info');
    var searchArea = productInfo || productSection || container.closest('.product') || document;
    var productForm = searchArea.querySelector('form[action*="/cart/add"]');
    if (productForm) {
      var idInput = productForm.querySelector('input[name="id"]');
      if (idInput) {
        idInput.value = pill.getAttribute('data-variant-id');
        idInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
      var quantityInput = productForm.querySelector('input[name="quantity"], .quantity__input');
      if (quantityInput) {
        quantityInput.value = 1;
        quantityInput.dispatchEvent(new Event('input', { bubbles: true }));
        quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  });
})();
  } catch(e) { console.error(e); }
})();

})();
